import Vue from 'vue'
export default {
    requests: Vue.observable({}),
}